var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeaderAiPickIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.45 19.553c.333.2.683.296 1.05.288a2.096 2.096 0 001.05-.313l4.55-2.775a9.498 9.498 0 00-2.675-1.312 9.946 9.946 0 00-2.925-.438c-1 0-1.979.146-2.937.438-.958.293-1.862.722-2.713 1.287l4.6 2.825zm1.05-6.55c.967 0 1.792-.341 2.475-1.025A3.372 3.372 0 0016 9.503c0-.967-.342-1.792-1.025-2.475A3.372 3.372 0 0012.5 6.003c-.967 0-1.792.342-2.475 1.025A3.372 3.372 0 009 9.503c0 .967.342 1.792 1.025 2.475a3.372 3.372 0 002.475 1.025zm-1.05 8.875l-7-4.3a1.975 1.975 0 01-.95-1.7v-7.75a1.975 1.975 0 01.95-1.7l7-4.3c.333-.2.683-.3 1.05-.3s.717.1 1.05.3l7 4.3a1.975 1.975 0 01.95 1.7v7.75a1.975 1.975 0 01-.95 1.7l-7 4.3c-.333.2-.683.3-1.05.3s-.717-.1-1.05-.3z",
    fill: "#CDCDCD"
  })));
}

export default SvgHeaderAiPickIcon;